import React, { Component } from "react";
import Subjektif from "../keperawatan/Subjektif";
import Objektif from "../form/Objektif.js";
import Assesment from "../keperawatan/Assesment";
import Planning from "../keperawatan/Planning";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { DetilPxContext } from "../../context";
import apiService from "apiService";

export default class Keperawatan extends Component {
  static contextType = DetilPxContext;
  constructor(props) {
    super(props);
    this.state = {
      visitId: 1000,
      modules: [
        { id: "1", name: "Subjektif" },
        { id: "2", name: "Objektif" },
        { id: "3", name: "Assesment" },
        { id: "4", name: "Planning" },
      ],
      visible: false,
      detilPx: this.props.detilPx,
      tabIndex: 0,
    };
    this.parentCallback = this.parentCallback.bind(this);
    this.nextTab = this.nextTab.bind(this);
  }

  buttonClick = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    // console.log(this.state);
  };
  parentCallback(data) {
    this.setState((prevState) => ({
      detilPx: {
        // object that we want to update
        ...prevState.detilPx, // keep all other key-value pairs
        [data.param]: data.data,
      },
    }));
    // console.log(data);
  }
  nextTab() {
    const tabs = this.state.tabIndex;
    const tabIndex = tabs + 1;
    this.setState({ tabIndex: tabIndex });
  }

  getData = async () => {
    let param = {
      keyword: {
        visitId: this.state.detilPx.id,
      },
      limit: 10,
      frDate: "",
      enDate: "",
    };
    const res = await apiService.post("registration", param);
    // console.log(res)
    if (res?.status === "success.") {
      this.setState({
        detilPx: res.data.data[0],
      });
      this.context.changeDetilPx(res.data.data[0]);
      // this.forceUpdate();
    }
  };

  render() {
    var patient = this.state.detilPx;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Form Keperawatan</h4>
              </div>
            </div>
          </div>
          <div className="card-body">
            <Tabs
              selectedIndex={this.state.tabIndex}
              onSelect={(tabIndex) => this.setState({ tabIndex })}
            >
              <TabList>
                <Tab id="Subjektif">Subjektif </Tab>
                <Tab id="Objektif">Objektif </Tab>
                <Tab id="Assesment">Assesment </Tab>
                <Tab id="Planning">Planning </Tab>
              </TabList>
              <TabPanel tabId="Subjektif">
                <Subjektif
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                  getData={this.getData}
                />
              </TabPanel>
              <TabPanel tabId="Objektif">
                <Objektif
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Assesment">
                <Assesment
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Planning">
                <Planning
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                  getData={this.getData}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
